import PropTypes from "prop-types";

export const AccentYellow = ({ children }) => {
  return <span style={{ color: "#f1c233" }}>{children}</span>;
};

AccentYellow.propTypes = {
  children: PropTypes.node,
};
